import {
    Box,
    Chip,
    Grid,
    TextField,
    Typography
} from "@mui/material";
import * as React from "react";
import GenericDialog from "../../../components/dialog/generic-dialog.component";
import {translate} from "../../../translate/translate";
import {AssociateProject, Project} from "../../../models/basic/project";
import TableActionComponent from "../../../components/table/table-action.component";
import TablePaginationComponent from "../../../components/table/table-pagination.component";
import {ErrorComponent} from "../../../components/error/error.component";
import {PaginatedResult} from "../../../models/default/paginated-result";
import {useEffect} from "react";
import {Field, Form, Formik} from "formik";
import {toast} from "react-toastify";
import {sortListObj} from "../../../utils/list-utils";
import {ProjectFilter, ProjectService} from "../../../services/project-service";
import {useFilters} from "../../../filters/base-filter";
import {usePagination} from "../../../utils/pagination";
import {PoMonitoringService} from "../../../services/po-monitoring-service";

const AddProjectComponent = (props: any) => {
    const {
        openDialog,
        handleCloseDialog,
        isDisabled,
        id,
        projects,
    } = props;

    const [selectedProject, setSelectedProject] = React.useState<Project[]>(sortListObj(projects, "name") || []);
    const saveService = new PoMonitoringService();

    const service = new ProjectService();
    const {filters, updateFilter, resetFilters } = useFilters<ProjectFilter>({ name: "", active: "", client: "", po_id: "" }, []);
    const [projectList, setProjectList] = React.useState<PaginatedResult<Project>>();
    const {
        dataSource,
        pagination,
        resetPage,
        handleChangePage,
        handleChangeRowsPerPage
    } = usePagination<Project>(projectList);

    useEffect(() => {
        setSelectedProject(projects);
        openDialog && search();
    }, [projects, openDialog]);

    const search = (restartIndex = false) => {
        const newFilters = {...filters, po_id: id};
        service.readPaginated(newFilters, [], pagination).then(response => {
            setProjectList(response.data);
        }).catch((error: any) => {
            ErrorComponent(error);
        });
        restartIndex && resetPage();
    };

    useEffect(() => {
        search();
    }, [pagination, filters.name]);

    const handleRowSelect = (row: Project) => {
        const index = selectedProject.findIndex(item => item.id === row.id);
        if (index === -1) {
            const p = [...selectedProject, row];
            setSelectedProject(sortListObj(p, "name"));
        } else {
            const newSelected = selectedProject.filter(item => item.id !== row.id);
            setSelectedProject(sortListObj(newSelected, "name"));
        }
    }

    const handleSubmit = (selectedProject: Project[]) => {
        const projects = selectedProject.map(item => {
            return {project_id: item.id, project_name: item.name}
        }) as AssociateProject[];
        saveService.associateWithProjects(id, projects).then(response => {
            toast.success(translate.t("successfully_updated"));
            setSelectedProject([]);
            resetFilters();
            resetPage();
            handleCloseDialog(true);
        }).catch((error: any) => {
            ErrorComponent(error);
        });
    }

    return (
        <GenericDialog
            open={openDialog}
            onClose={() => {
                setSelectedProject([]);
                updateFilter("name", "");
                resetPage();
                handleCloseDialog();
            }}
            title={"add_project"}
            colorButton={"primary"}
            labelButton={"save"}
            maxWidth={"md"}
            disableConfirm={isDisabled || !selectedProject.length}
            handleConfirm={() => handleSubmit(selectedProject)}>
            <Box>
                <Typography style={{
                    fontWeight: 'bold'}}>
                    {translate.t("selected_projects")}
                </Typography>
                <Box sx={{width: "100%",
                          padding: "1rem",
                          marginTop: "0.5rem",
                          textAlign: !selectedProject.length ? "center" : "flex-start",
                          marginBottom: "1rem",
                          backgroundColor: "#edf1fe"}}>
                    {!selectedProject.length ? (
                        <Typography>{translate.t("no_projects_selected")}.</Typography>
                    ) : (selectedProject.map((item, index) => (
                        <Chip key={item.id} size="small"
                              style={{marginRight: '5px', marginBottom: '5px'}}
                              onDelete={() => handleRowSelect(item)}
                              label={item.name}/>
                    )))}
                </Box>
                <Formik
                    enableReinitialize={true}
                    validateOnMount={true}
                    initialValues={{name: ""}}
                    onSubmit={(values, {setSubmitting}) => {
                        setTimeout(() => {
                            search(true);
                            setSubmitting(false);
                        }, 500);
                    }}
                >
                    {
                        () => (
                            <Form autoComplete="off">
                                <Grid alignItems="center" container spacing={2} direction={"row"} width="70%">
                                    <Grid >
                                        <Field
                                            as={TextField}
                                            name="name"
                                            label={translate.t("search_project")}
                                            fullWidth
                                            size="small"
                                            variant={"outlined"}
                                            autoFocus={true}
                                            value={filters.name}
                                            onChange={(event: React.ChangeEvent<{
                                                value: string
                                            }>) => updateFilter("name", event.target.value)}
                                        />
                                    </Grid>
                                </Grid>
                            </Form>
                        )}
                </Formik>
                <Box style={{marginTop: '0.5rem'}}>
                    <TablePaginationComponent
                        state={dataSource}
                        displayedColumnsShow={["", "projects"]}
                        displayedColumns={["isRowSelectable", "name"]}
                        dateColumns={["purchase_date"]}
                        count={projectList?.count}
                        next={projectList?.next}
                        previous={projectList?.previous}
                        page={pagination.page}
                        onPageChange={handleChangePage}
                        rowsPerPage={pagination.limit}
                        handleChangeRowsPerPage={handleChangeRowsPerPage}
                        actionsComponent={TableActionComponent}
                        columnStyles={{1:"10%", 2:"90%"}}
                        showActions={["edit", "delete"]}
                        rowsPerPageOptions={[10, 50, 100]}
                        selectedRows={selectedProject}
                        handleRowSelect={handleRowSelect}
                    />
                </Box>
            </Box>
        </GenericDialog>
    )
}

export default AddProjectComponent;
